import { render, staticRenderFns } from "./DepartureForm.vue?vue&type=template&id=58f338ca"
import script from "./DepartureForm.vue?vue&type=script&lang=js"
export * from "./DepartureForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports